const language = {
	spanish: {
		inicio: "Inicio",
		about: "Acerca de Foresight GPS",
		industrias: "Industrias",
		familias: "Familias",
		soluciones: "Gevolution",
		aliados: "Aliados",
		recursos: "Recursos",
		contacto: "Contacto",
		yellow_button: "centro de soporte",
		option_1: "Español",
		option_2: "Inglés",
	},
	english: {
		inicio: "Home",
		about: "About Foresight GPS",
		industrias: "Industries",
		familias: "Families",
		soluciones: "Gevolution",
		aliados: "Allies",
		recursos: "Resources",
		contacto: "Contact",
		yellow_button: "Support Center",
		option_1: "Spanish",
		option_2: "English",
	},
};

export default language;